<template>
    <BreadCrumb PageTitle="Modifier les informations de l'Etape 1 d'un Besc" />
    <EditAddBescStep1/>
  </template>
  
  <script lang="ts">
  
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import EditAddBescStep1 from "@/components/BESC/EditBesc/EditAddBescStep1.vue";
   

    export default defineComponent({
      name: "EditAddBescStep1Page",
      components: {
        BreadCrumb,
        EditAddBescStep1,
      },
    });
  </script>